import styled from "styled-components";

export const HeaderMainDiv = styled.div`
  margin: 20px 0 10px;
  width: 100%;
  display: flex;
  background-color: #e3e3e3;
`;
export const HeaderDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  align-items: flex-end;
`;
export const Title = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: ${({ align }) => align && align};
`;
